import { IconButton } from '@mui/material';
import { useHistory } from 'react-router-dom';
import KenColors from '../../Helpers/Themes/kenColors';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

const GoBackIcon = ({ needBGgColor = true }) => {
  const navigate = useHistory();
  return (
    <IconButton
      onClick={() => {
        navigate.goBack();
      }}
      sx={{
        padding: { xs: '9px', ultraHD: '10px' },
        height: { xs: '36px', ultraHD: '48px' },
        width: { xs: '36px', ultraHD: '48px' },
        backgroundColor: needBGgColor ? KenColors.ClientRoyalpurple50 : 'transparent',
        '&:hover': {
          backgroundColor: needBGgColor ? KenColors.ClientRoyalpurple50 : 'transparent',
        },
        borderRadius: { xs: '6px', ultraHD: '8px' },
      }}
    >
      <ArrowBackOutlinedIcon
        sx={{
          fontSize: { xs: '18px', ultraHD: '24px' },
          color: KenColors.ClientBlack2,
        }}
      />
    </IconButton>
  );
};

export default GoBackIcon;
